<template>
    <div class="resources-folder-grid">
        <ResourcesFolderCard
            v-for="file in this.files"
            :id="file.id"
            :key="file.id"
            :description="file.description"
            :file-count="file.count"
            :image="file.thumbnail"
            :title="file.name"
        />
    </div>
</template>

<script>
import ResourcesFolderCard from './ResourcesFolderCard.vue';
export default {
    name: 'ResourcesFolderGrid',
    components: { ResourcesFolderCard },
    props: {
        files: {
            default: [],
        },
    },
};
</script>

<style scoped>
.resources-folder-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
}
@media only screen and (max-width: 600px) {
    .resources-folder-grid {
        grid-template-columns: 1fr;
    }
}
</style>
